import React from 'react';
import styles from './SortPanel.module.css';

const SortPanel = ({
  selectedSortOption,
  onSortChange
}) => {
  return (
    <div className={styles.sortPanel}>
      <div className={styles.sortSection}>
        <div className={styles.sortSectionTitle}>Sort By</div>
        <div className={styles.sortOptions}>
          <div className={styles.sortOption}>
            <input
              type="radio"
              id="sort-date-desc"
              name="sortOption"
              checked={selectedSortOption === 'date-desc'}
              onChange={() => onSortChange('date-desc')}
              className={styles.sortCheckbox}
            />
            <label htmlFor="sort-date-desc" className={styles.sortLabel}>Newest First</label>
          </div>
          <div className={styles.sortOption}>
            <input
              type="radio"
              id="sort-date-asc"
              name="sortOption"
              checked={selectedSortOption === 'date-asc'}
              onChange={() => onSortChange('date-asc')}
              className={styles.sortCheckbox}
            />
            <label htmlFor="sort-date-asc" className={styles.sortLabel}>Oldest First</label>
          </div>
          <div className={styles.sortOption}>
            <input
              type="radio"
              id="sort-name"
              name="sortOption"
              checked={selectedSortOption === 'name'}
              onChange={() => onSortChange('name')}
              className={styles.sortCheckbox}
            />
            <label htmlFor="sort-name" className={styles.sortLabel}>Name (A-Z)</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortPanel;
